
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 96 71","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"line",attrs:{"d":"M14.4 35.5H0"}}),_c('path',{staticClass:"line",attrs:{"d":"M24.222 11.676L14.04 1.494"}}),_c('path',{staticClass:"line",attrs:{"d":"M71.723 11.731L81.849 1.527"}}),_c('path',{staticClass:"line",attrs:{"d":"M24.183 59.24L14.001 69.422"}}),_c('path',{staticClass:"line",attrs:{"d":"M81.849 35.5H96"}}),_c('path',{staticClass:"line",attrs:{"d":"M71.687 59.149l10.276 10.275"}})])
          )
        }
      }
    